// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const PlanTasksTimelineViewLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-plantaskstimelineview" */ "./PlanTasksTimelineView")).then((page)=>{
        return {
            default: page.PlanTasksTimelineView
        };
    });
export const LazyPlanTasksTimelineView = /*#__PURE__*/ lazy(PlanTasksTimelineViewLazyLoader);
